module.exports = __webpack_public_path__ + "static/img/aa-7.36df3e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-7.png
// module id = DRj4
// module chunks = 1